import { Skeleton } from '@/shared/components';

export const UserBalanceSkeleton = () => {
  return (
    <div className="p-[1.2rem] w-full">
      <div className="flex items-center gap-[1.2rem]">
        <Skeleton
          variant="avatar"
          backgroundColor="primary"
          className="w-[4.2rem] h-[4.2rem]"
        />

        <div className="flex flex-col justify-center flex-1 gap-[0.4rem] h-[4.4rem]">
          <Skeleton
            variant="medium"
            backgroundColor="white"
            className="w-[13rem] h-[1.2rem]"
          />

          <Skeleton
            variant="medium"
            backgroundColor="white"
            className="w-[8.3rem] h-[1.2rem]"
          />
        </div>
      </div>
    </div>
  );
};
